<script setup lang="ts">
import SpotifyPlaylistDisplayElement from '~/components/spotify/SpotifyPlaylistDisplayElement.vue'

import { useSegmentTrack } from '~/composables/Segment/useSegmentTrack'

import type { SpotifyPlaylistFollowers } from '~/types/SpotifyApi'

type Props = {
  spotifyPlaylists: SpotifyPlaylistFollowers[]
}

const { spotifyPlaylists } = defineProps<Props>()
const segmentTrack = useSegmentTrack()

function handleIframeClick(): void {
  segmentTrack('Curator Profile - Spotify Player Clicked')
}
</script>

<template>
  <ul
    class="tw-grid tw-grid-cols-1 tw-gap-sm md:tw-grid-cols-2 lg:tw-place-items-start"
  >
    <SpotifyPlaylistDisplayElement
      v-for="(
        { spotify_id: spotifyPlaylistId, followers }, index
      ) in spotifyPlaylists"
      :key="index"
      html-tag="li"
      :spotify-playlist-id="spotifyPlaylistId"
      :followers="followers"
      small
      class="tw-flex tw-w-full tw-flex-wrap tw-items-center tw-overflow-hidden"
      @iframe-click="handleIframeClick"
    />
  </ul>
</template>
